import { createReducer } from '../../../utils';
import { combineReducers } from 'redux';
import constant from './constant';



const agentCurveDataHandlers = {
    [constant.agentCurveData](state, action) {
        return action.payload;
    }
};

const widthDataHandlers = {
    [constant.widthData](state, action) {
        return action.payload;
    }
};
const connectDataHandlers = {
    [constant.connectData](state, action) {
        return action.payload;
    }
};
const multiCurveDataHandlers = {
    [constant.multiCurveData](state, action) {
        return action.payload;
    }
};
const pieDataHandlers = {
    [constant.pieData](state, action) {
        return action.payload;
    }
};
const bandwidthDetailHandlers = {
    [constant.bandwidthDetail](state, action) {
        return action.payload;
    }
};
const bandwidthDetailSortHandlers = {
    [constant.agentSort](state, action) {
        return action.payload;
    }
};


const agentsHandlers = {
    [constant.agents](state, action) {
        return action.payload;
    }
};
const areasHandlers = {
    [constant.areas](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return { ...state, loading: action.payload };
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer({ loading: false }, loadingHandlers);
export const agentCurveData = createReducer([], agentCurveDataHandlers);
export const widthData = createReducer([], widthDataHandlers);
export const connectData = createReducer([], connectDataHandlers);
export const multiCurveData = createReducer([], multiCurveDataHandlers);
export const pieData = createReducer([], pieDataHandlers);

export const bandwidthDetail = createReducer([], bandwidthDetailHandlers);
export const bandwidthDetailSort = createReducer([], bandwidthDetailSortHandlers);

export const search = createReducer({}, searchHandlers);
export const agents = createReducer([], agentsHandlers);
export const areas = createReducer([], areasHandlers);

export const widthAndConnect = combineReducers({
    loading,
    agentCurveData,
    widthData,
    connectData,
    multiCurveData,
    pieData,
    bandwidthDetail,
    bandwidthDetailSort,
    search,
    agents,
    areas,
})






// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/widthAndConnect/reducers.js